import { render, staticRenderFns } from "./selectInfo.vue?vue&type=template&id=1f5dfe33&scoped=true"
import script from "./selectInfo.vue?vue&type=script&lang=js"
export * from "./selectInfo.vue?vue&type=script&lang=js"
import style0 from "./selectInfo.vue?vue&type=style&index=0&id=1f5dfe33&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f5dfe33",
  null
  
)

export default component.exports